export default "__VITE_ASSET__BZEBYtQl__"